import React from "react";
import { Box, Typography, Avatar, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { getRuta, simpleMessage } from "../helpers/Helpers";
import { apiLogOut, getRol, getUser } from "../api/Account";
import { sidebar } from "../theme";

// Bloque de usuario en el pie del sidebar — ver design_handoff_crediapp_redesign/README.md (Shell).
// Sustituye al menú desplegable que antes vivía en el topbar (NavBarElements):
// click en el perfil -> Mi cuenta, icono de logout -> cerrar sesión (mismo flujo de antes).
const SidebarFooter = ({ setIsLogged, setIsDarkMode }) => {
  const navigate = useNavigate();
  const user = getUser();
  const rol = getRol();
  const rout = getRuta();

  const initials = user
    ? `${user.split(" ")[0][0] || ""}${(user.split(" ")[1] || "")[0] || ""}`
    : "";

  const goToAccount = () => {
    navigate(`${rout}/account`);
  };

  const logOut = () => {
    const result = apiLogOut();
    if (!result.statusResponse) {
      simpleMessage("No se pudo cerrar sesion, intente de nuevo", "error");
    }
    setIsDarkMode(false);
    setIsLogged(false);
    navigate(rout);
  };

  return (
    <Box
      sx={{
        marginTop: "auto",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px",
        backgroundColor: "rgba(255,255,255,.05)",
        borderRadius: "14px",
      }}
    >
      <Box
        onClick={goToAccount}
        sx={{ display: "flex", alignItems: "center", gap: "12px", flex: 1, minWidth: 0, cursor: "pointer" }}
      >
        <Avatar sx={{ width: 38, height: 38, borderRadius: "10px", bgcolor: "#12a35a", fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: 14, flexShrink: 0 }}>
          {initials}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              color: sidebar.userColor,
              fontSize: 13.5,
              fontWeight: 700,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user || ""}
          </Typography>
          <Typography sx={{ color: sidebar.mutedColor, fontSize: 11.5 }}>{rol || ""}</Typography>
        </Box>
      </Box>
      <IconButton
        onClick={logOut}
        title="Cerrar sesión"
        sx={{ color: sidebar.mutedColor, "&:hover": { color: "#ff8585" } }}
      >
        <LogoutRoundedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default SidebarFooter;
